// extracted by mini-css-extract-plugin
module.exports = {"Center":"Item_Center__3BTqr","TextCounter":"Item_TextCounter__3_tiZ","itemCenter":"Item_itemCenter__308EL"};